module.exports = __webpack_public_path__ + "img/katarina_amenities_1.8f701626.jpg";